import React from "react";
import "./../../HairInnerServicePage/HairCut/HairCutBenefits/HairCutBenefits.css"

const HairColorProcess = () => {
  return (
    <div className="hairCutBenefitsContainer">
      <h2>The Process: What to Expect</h2>
      <p>
        When you choose SCENT for your Hair Colour in Bangalore, you can expect
        a thorough and professional experience from start to finish. Here's what
        the process typically involves:
      </p>
        <li>
          <h6> 1. Consultation:</h6>
          <p>
            Our stylists will begin with a detailed
            consultation to understand your desired look, hair type, and
            lifestyle. We'll discuss the best color options and techniques to
            achieve your goals.
          </p>
        </li>
        <li>
          <h6> 2. Preparation:</h6>
          <p>
            Before applying color or highlights, we'll prepare
            your hair to ensure optimal results. This may include a deep
            conditioning treatment or a haircut to remove any damaged ends.
          </p>
        </li>
        <li>
          <h6>3. Application:</h6>
          <p>
             Our expert colorists will carefully apply the chosen
            color or highlights, using precision techniques to achieve a
            flawless finish. We take great care to ensure that the color is
            evenly distributed and blended for a natural look.
          </p>
        </li>
        <li>
          <h6>4. Processing:</h6>
          <p>
             Once the color is applied, we'll allow it to process
            for the recommended time. Our stylists will monitor the process
            closely to ensure that the color develops correctly.
          </p>
        </li>
        <li>
          <h6>5. Rinse and Style:</h6>
          <p>
             After the processing time, we'll rinse your hair
            thoroughly and apply a post-color treatment to lock in moisture and
            shine. Our stylists will then blow-dry and style your hair to
            perfection.
          </p>
        </li>
        <li>
          <h6>6. Aftercare: </h6>
          <p>
            We'll provide you with personalized aftercare tips and
            product recommendations to maintain your new color and keep your
            hair healthy.
          </p>
        </li>
    </div>
  );
};

export default HairColorProcess;
